import { create } from "apisauce";
import jwtDecode from "jwt-decode";
import { BehaviorSubject } from "rxjs";
import { error, success } from "../redux/notificationSlice";
import { store } from "../redux/store";

import spinnerSvc from "./spinner-service";

export const authApi = create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: { Accept: "application/json" },
});

authApi.axiosInstance.interceptors.request.use((config) => {
  spinnerSvc.start();
  return config;
});

authApi.axiosInstance.interceptors.response.use(
  (response) => {
    spinnerSvc.stop();
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      store.dispatch(error(error.response.data));
      spinnerSvc.stop();
      return null;
    } else {
      // store.dispatch(error(error.message))
      spinnerSvc.stop();
      return null;
    }
  }
);

class AuthService {
  isValidating$ = new BehaviorSubject(false);
  loginBehavior = new BehaviorSubject(true);
  lastRefreshTime = new Date();
  loginObservable$;
  role = "";
  constructor() {
    this.loginObservable$ = this.loginBehavior.asObservable();
  }
  async changePassword(oldPassword, newPassword) {
    try {
      const token = localStorage.getItem("idToken") || "";
      const response = await authApi.post(
        "/change-password",
        { password: oldPassword, newPassword: newPassword },
        {
          headers: {
            authorization: token,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );

      if (response && response.ok) {
        store.dispatch(success({ message: "Password updated" }));
        return true;
      } else {
        store.dispatch(error("Invalid username / password"));
        return false;
      }
    } catch (err) {
      store.dispatch(error("Invalid old password "));
      return false;
    }
  }
  async recieveOTP(email) {
    try {
      const response = await authApi.post(
        "/forget-password",
        { email: email },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );

      if (response && response.ok) {
        store.dispatch(success({ message: "verification code send" }));
        return true;
      } else {
        store.dispatch(error("Invalid email"));
        return false;
      }
    } catch (err) {
      store.dispatch(error("Invalid email"));
      return false;
    }
  }
  async confirmOTP(email, code) {
    try {
      const response = await authApi.post(
        `verify-code`,
        { email, code },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );

      if (response && response.ok) {
        store.dispatch(success({ message: "code verified successfully" }));
        return true;
      } else {
        store.dispatch(error("Invalid code"));
        return false;
      }
    } catch (err) {
      store.dispatch(error("Invalid code"));
      return false;
    }
  }
  async changeForgetPassword(email, password) {
    try {
      const response = await authApi.put(
        `update-password`,
        { email, password },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );

      if (response && response.ok) {
        store.dispatch(success({ message: "password changed successfully" }));
        return true;
      } else {
        store.dispatch(error("Invalid email"));
        return false;
      }
    } catch (err) {
      store.dispatch(error("Invalid email"));
      return false;
    }
  }
  async login(email, password) {
    try {
      const response = await authApi.post("login", { email, password });

      if (response.ok) {
        const tokenBase64 = response.data.data.accessToken;
        const tokenData = jwtDecode(tokenBase64);
        this.role = tokenData.role;
        localStorage.setItem("user", JSON.stringify(tokenData));
        this.storeTokens(response.data.data);
        this.lastRefreshTime = new Date();
        return { isLoggedIn: true, user: tokenData };
      }
      throw new Error("Invalid credentials");
    } catch (err) {
      console.error(err);
      store.dispatch(error("Invalid credentials"));
      return { isLoggedIn: false };
    }
  }

  logout() {
    this.loginBehavior.next(false);
  }

  async refresh() {
    const token = localStorage.getItem("idToken");
    const refreshToken = localStorage.getItem("refreshToken");
    try {
      const { data, ok } = await authApi.post("refresh-token", {
        token,
        refreshToken,
      });

      if (ok) {
        const tokenBase64 = data.data.accessToken;
        const tokenData = jwtDecode(tokenBase64);
        this.role = tokenData.role;
        this.storeTokens(data.data);
        this.lastRefreshTime = new Date();
        return true;
      }
      throw new Error("expired token");
    } catch (err) {
      console.log(err);
      this.logout();
      return false;
    }
  }

  storeTokens(tokens) {
    const { refreshToken, accessToken } = tokens;
    localStorage.setItem("idToken", accessToken);
    localStorage.setItem("refreshToken", refreshToken);
    localStorage.setItem("loggedIn", true);
  }
}

const authSvc = new AuthService();
export default authSvc;
